var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cookieconsent"},[_c('cookie-law',{attrs:{"buttonText":"J'accepte","buttonDecline":"true","buttonDeclineText":"Je refuse","message":"Ce site internet utilise des cookies utiles à votre navigation","buttonLinkNewTab":"true","buttonLink":"#/pages/cookies","buttonLinkText":"En savoir plus"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16ae97c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/CookieConsent.vue
// module id = null
// module chunks = 